export default __webpack_public_path__ + "static/media/俞敏洪.77a035f6.png";